<template lang="pug">
nav.v-internal-nav.internal-nav.internal-nav--pinned(

	:class="{'iternal-nav--open' : openMobileNav}"
)
	v-loader(:loading="loading")
	.internal-nav__overlay()
	.internal-nav__box

	.internal-nav__box-inner(v-if="!loading" )
		.internal-nav__container
			//- крупный логотип компании над шапкой — только десктоп-колонка;
			//- на мобильном фото стоит слева от названия/типа (блок ниже)
			.internal-nav__company-logo(v-if="data.company && data.company.logo && !isSm")
				img.internal-nav__company-logo-img(:src="data.company.logo" :alt="data.company.name")
			.internal-nav__head
				button.internal-nav__close(v-if="isSm")
					v-svg-icon.internal-nav__close-icon(icon="close" @click="controllerCloseMobileNav")
				//-button.internal-nav__back()
					v-icon.internal-nav__trigger-icon(:icon="'arrow-right'")
				//- href исторически ведёт на сам файл фото (data.logo.src); когда фото
				//- нет (нет аватара, либо группы 7/8 — см. lk_nav_data.php), падаем
				//- на ссылку профиля, чтобы не отдавать <a> без href
				component.internal-nav__logo(v-if="data.logo"
					:href="data?.logo?.src || data?.logo?.href"
					:target="data?.logo?.target"
					:is="data.logo.href ? 'a' : 'div'"
					)
					img.internal-nav__logo-image(
						v-if="data.logo?.src"
						:src="data.logo.src"
						alt="WB SSL")
					.internal-nav__logo-text(v-if="data.logo?.text") {{data.logo.text}}

			.internal-nav__company-info(v-if="data.company && (data.company.name || data.company.type)")
				//- на мобильном фото компании слева, текст правее с выключкой влево
				img.internal-nav__company-info-logo(v-if="isSm && data.company.logo" :src="data.company.logo" :alt="data.company.name")
				.internal-nav__company-text
					.internal-nav__company-name(v-if="data.company.name") {{data.company.name}}
					.internal-nav__company-type(v-if="data.company.type") {{data.company.type}}

			.internal-nav__top(v-if="data.topItems && data.topItems.length")
				template(v-for="({text, href, target, active = false}, index) in data.topItems" :key="index" )
					a.internal-nav__top-btn.btn.btn--primary.btn--round.btn--sm-f(:href="href" :target="target" :class="{'internal-nav__top-btn--active': active}") {{text}}
			.internal-nav__group.internal-nav__group--top.flc()
				template(v-for="(item, index) in data.items" :key="index")
					.internal-nav__item.flc
						a.internal-nav__btn(:href="item.link" :class="[item.className, {'internal-nav__btn--active': item.active}]" @click="handleItemClick($event, item)")
							| {{item.text}}
							template(v-if="item.info")
								.internal-nav__info {{item.info}}
			.internal-nav__group.internal-nav__group--bottom.flc(v-if="data.bottomItems && data.bottomItems.length")
				template(v-for="({text, className, href, target}, index) in data.bottomItems" :key="index" )
					.internal-nav__item.flc
						a.internal-nav__btn(
								:href="href || '#'"
								:target="target"
								:class="className")
								| {{ text || '' }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from "../scripts/controller/controller";
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			openMobileNav: false,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		controllerCloseMobileNav() {
			controller.closeLkMobileMenu();
		},

		handleItemClick(event, item) {
			if (!item?.confirmLogout) {
				return;
			}

			event.preventDefault();
			const link = item.link;
			const confirmModal = this.data?.logoutConfirm;
			const confirmText = confirmModal?.props?.['data-source']?.title || '';

			if (!link) {
				return;
			}

			// Защитный фолбэк на случай, если глобальный контроллер модалок ещё не
			// смонтирован: прямого выхода без подтверждения всё равно не будет.
			if (!confirmModal || !window.modalController) {
				if (!confirmText || window.confirm(confirmText)) {
					window.location.assign(link);
				}
				return;
			}

			controller.openModal({
				component: {
					...confirmModal,
					props: {
						...confirmModal.props,
						'data-source': {
							...confirmModal.props?.['data-source'],
							redirectOnConfirm: link,
						},
					},
				},
			});
		},

		mobileNavOpen() {
			this.openMobileNav = true;
		},

		mobileNavClose() {
			this.openMobileNav = false;
		},

		resizeHandler() {
			if(!this.isSm && this.openMobileNav) {
				this.openMobileNav = false;
				// держим состояние тоггла в контроллере в синхроне
				controller.closeLkMobileMenu();
			}
		},

	},

	created() {
		controller.events.on('lk-nav-open', this.mobileNavOpen);
		controller.events.on('lk-nav-close', this.mobileNavClose);
		window.addEventListener('resize', this.resizeHandler)
	}

}
</script>
